__turbopack_context__.v({
  "keyfact": "AqPhQW_keyfact",
  "keyfact--row": "AqPhQW_keyfact--row",
});
